import styled from 'styled-components';
import { rem } from 'polished';
import { StockModelListStyled } from '../StockModelListStyled';

export const StockModelListStyledOV = styled(StockModelListStyled)`
    .last-item-wrapper {
        .last-item-banner-container-button {
            button {
                min-height: ${rem('48px')};
                font-size: ${rem('14px')};
                font-family: ${({ theme }) => theme.fonts.fontBase};
                color: ${({ theme }) => theme.colors.black};
                background-color: ${({ theme }) => theme.colors.primary};
                border: 2px solid ${({ theme }) => theme.colors.primary};
                font-weight: normal;

                &:hover {
                    background-color: ${({ theme }) => theme.colors.black};
                    color: ${({ theme }) => theme.colors.white};
                    border: 2px solid ${({ theme }) => theme.colors.black};
                }
            }
        }
    }
`;
